import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    backgroundColor: 'white',
    'font-weight': '500',
    'font-size': '13px'
  }
}));
